export default interface ChangePasswordModel {
    password: string;
    password_confirmation: string;
}

export const getDefaultChangePasswordModel: ChangePasswordModel = {
    password: "",
    password_confirmation: ""
}